import React from 'react';
import {
	Grid,
	FormControl,
	FormLabel,
	FormControlLabel,
	Radio,
	RadioGroup,
	Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
	confirmText: {
		fontFamily: 'Poppins',
	},
}));

const MaritalStatus = ({ handleMaritalStatus, maritalStatus, upiData }) => {
	const { t } = useTranslation();
	const classes = useStyles();

	return (
		<div>
			<Typography className={classes.confirmText}>
				{t('confirm-marital-status')}
			</Typography>
			<FormControl component='fieldset' margin='normal'>
				<FormLabel component='legend' className={classes.confirmText}>
					{t('marital-status')}
				</FormLabel>
				<RadioGroup
					aria-label='gender'
					name='gender'
					onChange={handleMaritalStatus}
				>
					<Grid container>
						<Grid item>
							<FormControlLabel
								value='Single'
								control={
									<Radio color='default' disabled={upiData.status === 200} />
								}
								label={
									<span className={classes.confirmText}>{t('single')}</span>
								}
								checked={maritalStatus === 'Single'}
							/>
						</Grid>
						<Grid item>
							<FormControlLabel
								value='Married'
								control={
									<Radio color='default' disabled={upiData.status === 200} />
								}
								label={
									<span className={classes.confirmText}>{t('married')}</span>
								}
								checked={maritalStatus === 'Married'}
							/>
						</Grid>
					</Grid>
				</RadioGroup>
			</FormControl>
		</div>
	);
};

export default MaritalStatus;